module.exports = __webpack_public_path__ + "img/ico-email-rounded.5783ae80.svg";